FamilycardsImageLibrary.controller('editMyAccountFormController', [ '$scope', function( $scope ) {

	$scope.editUserForm = [];

}]);